import { defineAsyncComponent } from 'vue';

const IdfIconCoins = defineAsyncComponent(() => import('./coins/coins.vue.mjs'));
const IdfIconGift = defineAsyncComponent(() => import('./gift/gift.vue.mjs'));
const IdfIconHandHeart = defineAsyncComponent(() => import('./hand-heart/hand-heart.vue.mjs'));

export { IdfIconCoins, IdfIconGift, IdfIconHandHeart };
